import { PrivateRoute } from "@/components/auth"
import NotFound from "@/pages/error/NotFound"
import Notifications from "@/pages/notifications/Notifications"
import React from "react"
import { Route, Switch } from "react-router-dom"

export default function Public() {
  return (
    <Switch>
      <PrivateRoute exact path="/notifications">
        <Notifications />
      </PrivateRoute>

      <Route>
        <NotFound />
      </Route>
    </Switch>
  )
}
